<script>
export default {
	methods: {
		resolveShopCodeForProductsList(shopCode) {
			if (shopCode === null || shopCode === undefined) return shopCode;
			const normalizedShopCode = String(shopCode);
			const centralizedProductsList = this.$store.getCentralizedProductsList;
			if (!Array.isArray(centralizedProductsList) || centralizedProductsList.length === 0) {
				const shops = this.$store.getProfileShops;
				if (!Array.isArray(shops) || shops.length === 0) return normalizedShopCode;

				const currentShop = shops.find((s) => s && String(s.code) === normalizedShopCode);
				const unifiedInfo = currentShop?.unifiedProductsInfo;
				if (!unifiedInfo) return normalizedShopCode;
				if (unifiedInfo.canModifyCentralizedProducts) return normalizedShopCode;
				if (unifiedInfo.hasCentralizedProducts && unifiedInfo.parentShopCode) {
					return String(unifiedInfo.parentShopCode);
				}
				return normalizedShopCode;
			}

			const centralizedInfo = centralizedProductsList.find(
				(x) => x && String(x.shopCode) === normalizedShopCode
			);
			if (!centralizedInfo) return normalizedShopCode;
			if (centralizedInfo.canModifyCentralizedProducts) return normalizedShopCode;
			if (centralizedInfo.hasCentralizedProducts && centralizedInfo.parentShopCode) {
				return String(centralizedInfo.parentShopCode);
			}
			return normalizedShopCode;
		},
	},
};
</script>
